import CustomLanguageComponent from "./CustomLanguageChanger";

export default CustomLanguageComponent